import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { Col, Row, Button } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faListAlt, faPlus } from "@fortawesome/free-solid-svg-icons";

const FormItem = ({ addItem, item, cost, units, itemType, taxType, handleItem, handleUnits, handleCost, handleItemType, handleTaxType }) => {

    const [errors, setErrors] = useState({});

    useEffect(() => {

    }, []);

    const validateData = () => {
        let error = false;
        let errorsArr = {}
        if (item == "" || item == null || item == undefined) {
            errorsArr.item = "El Nombre del Item es Obligatorio";
            error = true;
        }

        if (cost == "" || cost == null || cost == undefined) {
            errorsArr.cost = "El costo del Item es obligatorio";
            error = true;
        }

        if (units == "" || units == null || units == undefined) {
            errorsArr.units = "La Cantidad del Item es obligatorio";
            error = true;
        }

        if (itemType == "" || itemType == null || itemType == undefined) {
            errorsArr.itemType = "El tipo de Item es Obligatorio";
            error = true;
        }

        if (taxType == "" || taxType == null || taxType == undefined) {
            errorsArr.taxType = "El tipo de Item es obligatorio";
            error = true;
        }

        setErrors(errorsArr);
        return error;
    }

    const addNewItem = () => {  
        if (!validateData()) {
            let valor_total = parseInt(cost) * parseInt(units);
            let valor_iva = 0;
            if (taxType == "IVA") {
                valor_iva = valor_total;
                valor_total = (valor_total) * 1.19;
                valor_iva =  Math.ceil(valor_total - valor_iva) 
            }
            let itemAdd = {
                item_nombre: item,
                costo: cost,
                cantidad: units,
                tipo_item: itemType,
                tipo_impuesto: taxType,
                valor_total: valor_total,
                valor_iva: valor_iva
            }
            addItem(itemAdd);
        }
    }

    return (
        <Row>
            <Col md={2}>
                <TextField
                    label="Item"
                    value={item}
                    onChange={(event) => {
                        handleItem(event.target.value);
                    }}
                    style={{ width: '100%' }}
                    className="medical-material-form__field"
                    InputLabelProps={{
                        style: { color: '#646777' }, 
                        shrink: item == "" || item == null || item == undefined ? false : true
                    }}
                    helperText={errors.hasOwnProperty("item") && (item == "" || item == null || item == undefined) ? errors.item : ""}
                    error={errors.hasOwnProperty("item") && (item == "" || item == null || item == undefined) ? true : false}
                />
            </Col>
            <Col md={2}>
                <TextField
                    label="Valor"
                    value={cost}
                    onChange={(event) => {
                        handleCost(event.target.value);
                    }}
                    type="number"
                    style={{ width: '100%' }}
                    className="medical-material-form__field"
                    InputLabelProps={{
                        style: { color: '#646777' }, 
                        shrink: cost == "" || cost == null || cost == undefined ? false : true
                    }}
                    helperText={errors.hasOwnProperty("cost") && (cost == "" || cost == null || cost == undefined) ? errors.cost : ""}
                    error={errors.hasOwnProperty("cost") && (cost == "" || cost == null || cost == undefined) ? true : false}
                />
            </Col>
            <Col md={2}>
                <TextField
                    label="Cantidad"
                    value={units}
                    onChange={(event) => {
                        handleUnits(event.target.value);
                    }}
                    type="number"
                    style={{ width: '100%' }}
                    className="medical-material-form__field"
                    InputLabelProps={{
                        style: { color: '#646777' }, 
                        shrink: units == "" || units == null || units == undefined ? false : true
                    }}
                    helperText={errors.hasOwnProperty("units") && (units == "" || units == null || units == undefined) ? errors.units : ""}
                    error={errors.hasOwnProperty("units") && (units == "" || units == null || units == undefined) ? true : false}
                />
            </Col>
            <Col md={2}>
                <TextField
                    value={itemType}
                    onChange={(event) => {
                        handleItemType(event.target.value);
                    }}
                    style={{ width: '100%' }}
                    className="medical-material-form__field"
                    select
                    name="typeItem"
                    id="typeItem"
                    label="Tipo de Item"
                    InputLabelProps={{
                        style: { color: '#646777' },
                        shrink: itemType == "" || itemType == null || itemType == undefined ? false : true
                    }}
                    helperText={errors.hasOwnProperty("itemType") && (itemType == "" || itemType == null || itemType == undefined) ? errors.itemType : ""}
                    error={errors.hasOwnProperty("itemType") && (itemType == "" || itemType == null || itemType == undefined) ? true : false}
                >
                    <MenuItem value={"Servicio"}>Servicio</MenuItem>
                    <MenuItem value={"Articulo"}>Articulo</MenuItem>
                </TextField>
            </Col>
            <Col md={2}>
                <TextField
                    className="medical-material-form__field"
                    select
                    name="taxType"
                    id="taxType"
                    label="Tipo de Impuesto"
                    value={taxType}
                    onChange={(event) => {
                        console.log("EVENTOIMPUESTO",event.target)
                        handleTaxType(event.target.value);
                    }}
                    InputLabelProps={{
                        style: { color: '#646777' },
                        shrink: taxType == "" || taxType == null || taxType == undefined ? false : true
                    }}
                    helperText={errors.hasOwnProperty("taxType") && (taxType == "" || taxType == null || taxType == undefined) ? errors.taxType : ""}
                    error={errors.hasOwnProperty("taxType") && (taxType == "" || taxType == null || taxType == undefined) ? true : false}
                >
                    <MenuItem value={"Sin Impuesto"}>Sin Impuesto</MenuItem>
                    <MenuItem value={"IVA"}>IVA 19%</MenuItem>
                </TextField>
            </Col>
            <Col md={2}>
                <Button
                    style={{ marginTop: 10 }}
                    outline
                    color="primary"
                    onClick={() => {
                        addNewItem();
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} />
                </Button>
            </Col>
        </Row>
    );
};
export default FormItem;